import { render, staticRenderFns } from "./fs-slider.vue?vue&type=template&id=a5531128&scoped=true"
import script from "./fs-slider.vue?vue&type=script&lang=js"
export * from "./fs-slider.vue?vue&type=script&lang=js"
import style0 from "./fs-slider.vue?vue&type=style&index=0&id=a5531128&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5531128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5531128')) {
      api.createRecord('a5531128', component.options)
    } else {
      api.reload('a5531128', component.options)
    }
    module.hot.accept("./fs-slider.vue?vue&type=template&id=a5531128&scoped=true", function () {
      api.rerender('a5531128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/form-elements/fs-slider.vue"
export default component.exports